export default __webpack_public_path__ + "static/media/closet5-before1-2048w.24f1da5a.webp";